import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import { canVisit } from '@/shared/lib/access'
import { preferredLoginMode } from '@/shared/lib/loginMode'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      component: () => import('@/components/Dashboard'),
      meta: { name: 'Главная', requiresAuth: true }
    },
    {
      path: '/operations',
      component: () => import('@/components/Operations'),
      meta: { name: 'Статистика перемещений', requiresAuth: true, company: false, statistic: true }
    },
    {
      path: '/unload',
      component: () => import('@/components/Load'),
      meta: { name: 'Ожидают приёмку', requiresAuth: true, company: false }
    },
    {
      path: '/load',
      component:() => import('@/components/Unload'),
      meta: { name: 'Ожидают отгрузку', requiresAuth: true, company: false }
    },
    {
      path: '/unload_vehicles',
      name: 'accepted_vehicles_path',
      component: () => import('@/components/Vehicle/Load'),
      meta: { name: 'Принятые машины', requiresAuth: true, company: false, filterCompany: true }
    },
    {
      path: '/vehicles/accepted',
      component: () => import('@/components/Vehicle/Accepted'),
      meta: { name: 'Принятые машины', requiresAuth: true, company: false, filterCompany: false }
    },
    {
      path: '/load_vehicles',
      name: 'shipped_vehicles_path',
      component: () => import('@/components/Vehicle/Unload'),
      meta: { name: 'Отгруженные машины', requiresAuth: true, company: false }
    },
    {
      path: '/unload_vehicles/:id(\\d+)',
      name: 'accepted_vehicle_path',
      component: () => import('@/components/Vehicle/Detail.vue'),
      meta: { name: 'Машина', recordParam: 'id', parent: 'accepted_vehicles_path', mobileBreadcrumb: true, requiresAuth: true, company: false }
    },
    {
      path: '/load_vehicles/:id(\\d+)',
      name: 'shipped_vehicle_path',
      component: () => import('@/components/Vehicle/Detail.vue'),
      meta: { name: 'Машина', recordParam: 'id', parent: 'shipped_vehicles_path', mobileBreadcrumb: true, requiresAuth: true, company: false }
    },
    {
      path: '/vehicles',
      component: () => import('@/components/Vehicle'),
      meta: { name: 'Машины', requiresAuth: true }
    },
    {
      path: '/work_shifts',
      component: () => import('@/components/WorkShift'),
      meta: { name: 'Смены', requiresAuth: true, company: true }
    },
    {
      path: '/calendar',
      component: () => import('@/components/WorkShift/CalendarNew'),
      meta: { name: 'Календарь смен', requiresAuth: true, company: false }
    },
    // Старые адреса календаря остаются рабочими: они разошлись по закладкам
    // и внешним ссылкам.
    { path: '/work_shifts_calendar', redirect: '/calendar' },
    { path: '/new-calendar', redirect: '/calendar' },
    { path: '/access-roles', component: () => import('@/components/AccessRoles'), meta: { section: 'admin', name: 'Роли и права', requiresAuth: true } },
    { path: '/access-denied', component: () => import('@/components/AccessRoles/Denied.vue'), meta: { name: 'Нет доступа', requiresAuth: true } },
    {
      path: '/users',
      component: () => import('@/components/Users'),
      meta: { section: 'admin', name: 'Пользователи', requiresAuth: true }
    },
    {
      path: '/companies',
      component: () => import('@/components/Companies'),
      meta: { section: 'admin', name: 'Компании', requiresAuth: true }
    },
    {
      path: '/shipment_slots',
      name: 'shipment_slots_path',
      component: () => import('@/components/AutoCarrier/SlotLoad.vue'),
      meta: { name: 'Нагрузка по слотам', parent: 'auto_carriers_path', mobileBreadcrumb: true, requiresAuth: true, company: false }
    },
    {
      path: '/auto_carriers/:id(\\d+)',
      component: () => import('@/components/AutoCarrier/Detail.vue'),
      meta: { name: 'Заявка', recordParam: 'id', parent: 'auto_carriers_path', mobileBreadcrumb: true, requiresAuth: true, company: false }
    },
    {
      path: '/auto_carriers',
      name: 'auto_carriers_path',
      component: () => import('@/components/AutoCarrier'),
      meta: { name: 'Заявки на отгрузку', requiresAuth: true, company: false }
    },
    {
      path: '/store_report',
      component: () => import('@/components/StoreReport'),
      meta: { section: 'documents', name: 'Реестр по хранению автомобилей', requiresAuth: true, company: true }
    },
    {
      path: '/dealers',
      component: () => import('@/components/Dealer'),
      meta: { section: 'settings', name: 'Дилер Коды', requiresAuth: true }
    },
    {
      path: '/settings',
      component: () => import('@/components/Settings'),
      meta: { name: 'Глобальные настройки', requiresAuth: true }
    },
    {
      path: '/vehicle_tickets',
      component: () => import('@/components/VehicleTickets'),
      meta: { section: 'documents', name: 'Состояние документов прибытия машин', requiresAuth: true, company: false }
    },
    {
      path: '/services',
      component: () => import('@/components/CustomServices'),
      meta: { section: 'settings', name: 'Справочник услуг', requiresAuth: true }
    },
    {
      path: '/report-services',
      component: () => import('@/components/ReportServices'),
      meta: { section: 'admin', name: 'Справочник для отчётов', requiresAuth: true }
    },
    {
      path: '/containers',
      component: () => import('@/components/Containers'),
      meta: { section: 'settings', name: 'Контейнера', requiresAuth: true }
    },
    {
      path: '/container-tickets',
      component: () => import('@/components/ContainerTickets'),
      meta: { section: 'documents', name: 'Статус контейнеров', requiresAuth: true }
    },
    {
      path: '/auto-trucks',
      component: () => import('@/components/AutoTrucks'),
      meta: { section: 'documents', name: 'Автовозы', requiresAuth: true }
    },
    {
      path: '/containers/:id/versions',
      component: () => import('@/components/ContainerHistory'),
      meta: {
        parent: 'containers',
        name: 'История контейнера',
        requiresAuth: true
      }
    },
    {
      path: '/document-trains',
      name: 'document-trains',
      component: () => import('@/components/Trains'),
      meta: { section: 'documents',
        name: 'Документы поездов',
        requiresAuth: true,
        company: false
      }
    },
    {
      path: '/document-trains/:id',
      name: 'train-containers',
      component: () => import('@/components/Trains/ContainerTickets'),
      meta: {
        parent: 'document-trains',
        requiresAuth: true,
        company: false,
        name: 'Документы контейнеров для поезда',
        parents: ['document-trains']
      }
    },
    {
      path: '/car-parks',
      name: 'car-parks',
      component: () => import('@/components/CarPark'),
      meta: { section: 'settings',
        requiresAuth: true,
        company: false,
        name: 'Ряды',
      }
    },
    {
      path: '/yard-map',
      name: 'yard-map',
      component: () => import('@/components/YardMap'),
      meta: {
        requiresAuth: true,
        company: false,
        name: 'Карта площадки',
      }
    },
    {
      path: '/styleguide',
      component: () => import('@/components/StyleGuide'),
      meta: { section: 'settings', name: 'Стили', requiresAuth: true, company: false }
    },
    {
      path: '/equipments',
      component: () => import('@/components/Equipment'),
      meta: { section: 'documents', name: 'Оборудование', requiresAuth: true, company: false, filterCompany: true }
    },
    {
      path: '/fastenings',
      component: () => import('@/components/Fastening'),
      meta: { section: 'documents', name: 'Крепёж', requiresAuth: true, company: false, filterCompany: true }
    },
    {
      path: '/fastening-models',
      component: () => import('@/components/FasteningModels'),
      meta: { section: 'settings', name: 'Модели крепежа', requiresAuth: true, company: false }
    },
    {
      path: '/stuffing-orders',
      name: 'stuffing-orders',
      component: () => import('@/components/StuffingOrders'),
      meta: { name: 'Заявки на затарку', requiresAuth: true, company: false }
    },
    {
      path: '/cargo-unload',
      component: () => import('@/components/CargoUnload'),
      meta: { name: 'Приёмка оборудования и крепежа', requiresAuth: true, company: false }
    },
    {
      path: '/car-parks/:id/items',
      component: () => import('@/components/CarPark/CarParkItems'),
      meta: {
        parent: 'car-parks',
        requiresAuth: true,
        company: false,
        name: 'Ячейки',
        parents: ['car-parks']
      }
    },
    {
      path: '/bookkeeping',
      component: () => import('@/components/BookKeeping'),
      meta: { section: 'documents',
        requiresAuth: true,
        company: false,
        name: 'Бухгалтерия',
      }
    },
    {
      path: '/inventory-vehicles',
      component: () => import('@/components/InventoryVehicles'),
      meta: { section: 'admin',
        requiresAuth: true,
        company: false,
        name: 'Инвентаризация машин',
      }
    },
    {
      path: '/table-report-containers',
      component: () => import('@/components/TableReportContainer'),
      meta: { section: 'documents',
        requiresAuth: true,
        company: false,
        name: 'Сводный отчёт по текущему положению контейнеров',
      }
    },
    { path: '/login', component: () => import('@/components/Signin'), name: 'login_path' },

    // Личный кабинет клиента-грузовладельца. Отдельная ветка со своим входом:
    // операторская авторизация здесь не действует и наоборот.
    {
      path: '/client/login',
      name: 'client_login',
      component: () => import('@/components/Client/Login'),
      meta: { client: true }
    },
    {
      path: '/client',
      component: () => import('@/components/Client/Vehicles'),
      meta: { client: true, clientAuth: true, name: 'Машины на хранении' }
    },
    {
      path: '/client/vehicles/:id',
      component: () => import('@/components/Client/VehicleDetail.vue'),
      meta: { client: true, clientAuth: true, name: 'Машина' }
    },
    {
      path: '/client/containers/demo',
      component: () => import('@/components/Client/ArrivalOrderDemo.vue'),
      meta: { client: true, clientAuth: true, name: 'Деморежим заявок на прибытие' }
    },
    {
      path: '/client/containers',
      component: () => import('@/components/Client/Containers'),
      meta: { client: true, clientAuth: true, name: 'Заявки на прибытие' }
    },
    {
      path: '/client/fastenings',
      component: () => import('@/components/Client/Fastenings'),
      meta: { client: true, clientAuth: true, name: 'Крепёж' }
    },
    {
      path: '/client/reports',
      component: () => import('@/components/Client/Reports'),
      meta: { client: true, clientAuth: true, name: 'Отчёты' }
    },
    {
      path: '/client/orders/demo',
      component: () => import('@/components/Client/ShipmentOrderDemo.vue'),
      meta: { client: true, clientAuth: true, name: 'Деморежим заявок на отгрузку' }
    },
    {
      path: '/client/orders',
      component: () => import('@/components/Client/Orders'),
      meta: { client: true, clientAuth: true, name: 'Заявки на отгрузку' }
    },
    {
      path: '/client/orders/:id(\\d+)',
      component: () => import('@/components/Client/OrderShow.vue'),
      meta: { client: true, clientAuth: true, name: 'Заявка' }
    },
    {
      path: '/client/threads',
      component: () => import('@/components/Client/Threads'),
      meta: { client: true, clientAuth: true, name: 'Обращения' }
    },
    {
      path: '/client/archives',
      component: () => import('@/components/Client/Archives'),
      meta: { client: true, clientAuth: true, name: 'Архивы фото' }
    },

    // Операторские страницы работы с кабинетом.
    {
      path: '/client-orders/:id(\\d+)',
      component: () => import('@/components/ClientOrders/Detail.vue'),
      meta: { name: 'Клиентская заявка', requiresAuth: true, company: false }
    },
    {
      path: '/client-orders',
      component: () => import('@/components/ClientOrders'),
      meta: { section: 'documents', name: 'Заявки клиентов', requiresAuth: true, company: false }
    },
    {
      path: '/client-threads',
      component: () => import('@/components/ClientThreads'),
      meta: { section: 'documents', name: 'Обращения клиентов', requiresAuth: true, company: false }
    },
    {
      path: '/mobile-app-releases',
      component: () => import('@/components/MobileAppReleases'),
      meta: { section: 'admin', name: 'Мобильное приложение', requiresAuth: true }
    },
    {
      path: '/client-users',
      component: () => import('@/components/ClientUsers'),
      meta: { section: 'admin', name: 'Клиентские аккаунты', requiresAuth: true }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  // Кабинет клиента живёт по своим правилам: у него отдельный токен, и
  // операторская проверка сюда не применяется.
  if (to.matched.some(record => record.meta.client)) {
    const loggedIn = store.getters.isClientLoggedIn

    if (to.name === 'client_login') {
      next(loggedIn ? '/client' : undefined)
      return
    }

    next(loggedIn ? undefined : '/client/login')
    return
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      try {
        if (!store.state.user || !Array.isArray(store.state.user.permissions)) await store.dispatch('current_user')
        if (canVisit(store.state.user, to.path)) next()
        else if (to.path === '/') next(['/unload_vehicles', '/cargo-unload', '/client-users', '/work_shifts'].find(path => canVisit(store.state.user, path)) || '/access-denied')
        else next('/access-denied')
      } catch (_) { next('/login') }
      return
    }
    next('/login')
  } else {
    if (to.name === 'login_path' && store.getters.isLoggedIn) {
      next('/')
      return
    }

    // На /login приводит и выход, и любая закрытая страница — это точка входа
    // по умолчанию. Если за этим компьютером входят в кабинет, показываем
    // кабинетскую форму: обратно её вернёт переключатель, который сохраняет
    // выбор до перехода. Адрес /client/login не трогаем — его вводят явно.
    if (to.name === 'login_path' && preferredLoginMode() === 'client') {
      next('/client/login')
      return
    }

    next()
  }
})

export default router
